import crmService from '@/services/crm_service'
import { recursiveAssign } from '@/utils'

const state = {
  products: { data: [] }
}

const mutations = {
  'SET_PRODUCTS' (state, products) {
    products.forEach(product => {
      const existing = state.products.data.find(p => p.id === product.id)
      if (!existing) state.products.data.push(product)
      else recursiveAssign(existing, product)
    })
  }
}

const actions = {
  getProducts ({ commit }, ids) {
    crmService.getProducts(ids, products => commit('SET_PRODUCTS', products))
  }
}

export default {
  state,
  mutations,
  actions
}
